<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid }">
    <div class="box">
      <div class="block">
        <BInputWithValidation
          rules="max:50|required"
          type="text"
          label="Name"
          v-model="dataCopy.name"
        />
      </div>
      <div class="block">
        <slot name="info"></slot>
      </div>
    </div>
    <div class="is-flex is-justify-content-end">
      <div class="buttons">
        <b-button v-if="showCloseBtn" @click="$emit('close')"
          >Schließen</b-button
        >
        <b-button
          type="is-gold"
          :disabled="invalid"
          @click="handleSubmit(submit)"
        >
          Speichern
        </b-button>
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
import BInputWithValidation from '@/components/inputs/BInputWithValidation.vue';

export default {
  name: 'SubproductForm',
  components: {
    BInputWithValidation,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    showCloseBtn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataCopy: { ...this.data },
    };
  },
  watch: {
    data: {
      deep: true,
      handler(newVal) {
        this.dataCopy = { ...newVal };
      },
    },
  },
  methods: {
    submit() {
      this.$emit('submit', { ...this.dataCopy });
    },
  },
};
</script>

<style>
</style>
